export default __webpack_public_path__ + "static/media/Nesha_Laser_0009_Laser_2.63a25cff.png";